var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlvarezMarsal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alvarez_Marsal",
    "data-name": "Alvarez & Marsal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.679,
    height: 13.168,
    viewBox: "0 0 164.679 13.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M465.058,392.927h2.517L473.4,405.79h-2.384l-1.691-3.883h-6.28l-1.757,3.883h-2.3Zm3.661,7.586-2.469-5.682-2.575,5.682Z",
    transform: "translate(-458.991 -392.927)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M464.678,394.123h1.635v8.414h5.975v1.134h-7.611Z",
    transform: "translate(-448.916 -390.808)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M468.627,394.123l3.423,8.132,3.4-8.132h1.81l-4.362,9.548h-1.718l-4.34-9.548Z",
    transform: "translate(-445.088 -390.808)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M474.342,394.123h1.824l4.335,9.548h-1.774l-1.256-2.877H472.8l-1.3,2.877h-1.657Zm2.672,5.623-1.835-4.213-1.9,4.213Z",
    transform: "translate(-439.77 -390.808)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M474.154,394.123h5.413a6.388,6.388,0,0,1,2.2.319,2.26,2.26,0,0,1,1.646,2.262,2.126,2.126,0,0,1-.444,1.4,3.1,3.1,0,0,1-1.25.881,2.5,2.5,0,0,1,1.059.6,1.829,1.829,0,0,1,.4,1.2l.066,1.278a3.232,3.232,0,0,0,.114.812.832.832,0,0,0,.518.582v.219h-2a.922.922,0,0,1-.128-.319,4.754,4.754,0,0,1-.075-.746l-.089-1.6a1.315,1.315,0,0,0-.84-1.255,3.983,3.983,0,0,0-1.405-.18h-3.553v4.1h-1.635Zm5.236,4.382a3.475,3.475,0,0,0,1.732-.366,1.577,1.577,0,0,0-.255-2.691,3.47,3.47,0,0,0-1.272-.191h-3.805V398.5Z",
    transform: "translate(-432.129 -390.808)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M478.108,394.123H485.7v1.156h-6.23v2.9h5.757v1.134h-5.757v3.229h6.3v1.134h-7.663Z",
    transform: "translate(-425.124 -390.808)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M481.417,402.6l7.32-7.347h-6.774v-1.134h8.827v1.109l-7.339,7.306h7.339v1.134h-9.373Z",
    transform: "translate(-419.263 -390.808)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M489.192,397.083a2.612,2.612,0,0,1-.349-1.242,2.529,2.529,0,0,1,1.05-2.07,4.417,4.417,0,0,1,2.81-.829,4.035,4.035,0,0,1,2.614.768,2.3,2.3,0,0,1,.942,1.832,2.925,2.925,0,0,1-.973,2.173,9.123,9.123,0,0,1-1.9,1.255l2.932,2.8q.27-.7.374-1.048a7.915,7.915,0,0,0,.219-.976h1.918a7.882,7.882,0,0,1-.743,2.372c-.371.757-.554,1.059-.554.915l2.81,2.733h-2.5l-1.508-1.43a7.581,7.581,0,0,1-1.641,1.114,6.846,6.846,0,0,1-2.993.621,5.158,5.158,0,0,1-3.642-1.078,3.276,3.276,0,0,1-1.134-2.42,3.085,3.085,0,0,1,1.1-2.425,12.623,12.623,0,0,1,2.522-1.483A6.73,6.73,0,0,1,489.192,397.083Zm4.745,7.189a4.234,4.234,0,0,0,1.339-.995l-3.628-3.539a10.742,10.742,0,0,0-2,1.255,2.079,2.079,0,0,0-.718,1.6,1.729,1.729,0,0,0,.931,1.574,3.877,3.877,0,0,0,1.99.546A4.523,4.523,0,0,0,493.937,404.272Zm-.155-7.264a1.783,1.783,0,0,0,.643-1.322,1.244,1.244,0,0,0-.469-.978,1.855,1.855,0,0,0-1.269-.413,1.943,1.943,0,0,0-1.682.646,1.2,1.2,0,0,0-.241.723,1.669,1.669,0,0,0,.366,1.02,10.472,10.472,0,0,0,1.228,1.28A8.507,8.507,0,0,0,493.782,397.008Z",
    transform: "translate(-409.499 -392.9)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M493.719,392.927h3.088l4.609,10.876,4.617-10.876h3.074V405.79h-2.048v-7.6c0-.258.017-.7.047-1.305s.039-1.258.039-1.951l-4.662,10.853h-2.162l-4.643-10.853v.4c0,.313.017.8.044,1.441s.044,1.117.044,1.419v7.6h-2.048Z",
    transform: "translate(-397.469 -392.927)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M504.227,394.123h1.824l4.335,9.548h-1.774l-1.253-2.877h-4.676l-1.3,2.877h-1.66Zm2.674,5.623-1.837-4.213-1.907,4.213Z",
    transform: "translate(-386.833 -390.808)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M504.076,394.123h5.415a6.393,6.393,0,0,1,2.206.319,2.26,2.26,0,0,1,1.646,2.262,2.112,2.112,0,0,1-.446,1.4,3.085,3.085,0,0,1-1.247.881,2.509,2.509,0,0,1,1.056.6,1.829,1.829,0,0,1,.4,1.2l.067,1.278a3.4,3.4,0,0,0,.111.812.841.841,0,0,0,.521.582v.219h-2a.978.978,0,0,1-.125-.319,5.581,5.581,0,0,1-.075-.746l-.089-1.6a1.316,1.316,0,0,0-.84-1.255,3.984,3.984,0,0,0-1.405-.18h-3.556v4.1h-1.635Zm5.238,4.382a3.487,3.487,0,0,0,1.735-.366,1.58,1.58,0,0,0-.255-2.691,3.481,3.481,0,0,0-1.272-.191h-3.811V398.5Z",
    transform: "translate(-379.121 -390.808)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M509.465,400.734a2.261,2.261,0,0,0,.457,1.319,3.341,3.341,0,0,0,2.724.951,5.514,5.514,0,0,0,1.594-.213q1.393-.391,1.391-1.436a1.17,1.17,0,0,0-.593-1.111,6.616,6.616,0,0,0-1.871-.563l-1.569-.294a8.114,8.114,0,0,1-2.17-.626,1.92,1.92,0,0,1-1.1-1.785,2.545,2.545,0,0,1,1.081-2.109,4.974,4.974,0,0,1,3.065-.823,6.207,6.207,0,0,1,3.1.723,2.449,2.449,0,0,1,1.275,2.306h-1.527a2.139,2.139,0,0,0-.5-1.172,3.218,3.218,0,0,0-2.4-.745,3.172,3.172,0,0,0-1.968.482,1.417,1.417,0,0,0-.6,1.12,1.065,1.065,0,0,0,.707,1.02,11.121,11.121,0,0,0,2.1.524l1.621.3a5.942,5.942,0,0,1,1.815.612,2.135,2.135,0,0,1,1.1,1.935,2.339,2.339,0,0,1-1.405,2.267,7.446,7.446,0,0,1-3.265.682,5.591,5.591,0,0,1-3.4-.912,2.811,2.811,0,0,1-1.2-2.447Z",
    transform: "translate(-372.285 -390.948)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M515.966,394.123h1.827l4.332,9.548h-1.774l-1.253-2.877h-4.673l-1.3,2.877h-1.657Zm2.677,5.623-1.835-4.213-1.912,4.213Z",
    transform: "translate(-366.031 -390.808)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M515.663,394.123H517.3v8.414h5.973v1.134h-7.611Z",
    transform: "translate(-358.594 -390.808)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlvarezMarsal);
export default __webpack_public_path__ + "static/media/AlvarezMarsal.5c55aa5a3a5a486ba98bd48162862c27.svg";
export { ForwardRef as ReactComponent };